/* Numa Product Page Scripts */
(function() {
  'use strict';

  /* Timer countdown */
  var timerEl = document.getElementById('ppTimer');
  var timerH = document.getElementById('ppTimerH');
  var timerM = document.getElementById('ppTimerM');
  var timerS = document.getElementById('ppTimerS');
  if (timerEl || timerM) {
    var total = 599;
    setInterval(function() {
      if (total <= 0) total = 599;
      total--;
      var m = Math.floor(total / 60);
      var s = total % 60;
      if (timerEl) timerEl.textContent = '00:' + String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
      if (timerH) timerH.textContent = '00';
      if (timerM) timerM.textContent = String(m).padStart(2, '0');
      if (timerS) timerS.textContent = String(s).padStart(2, '0');
    }, 1000);
  }

  /* Pricing option selection */
  document.querySelectorAll('.pp-pricing-option').forEach(function(opt) {
    opt.addEventListener('click', function() {
      document.querySelectorAll('.pp-pricing-option').forEach(function(o) { o.classList.remove('is-active'); });
      this.classList.add('is-active');
    });
  });

  /* Gallery thumbnail click */
  var mainImg = document.querySelector('.pp-gallery-main img');
  document.querySelectorAll('.pp-gallery-thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      document.querySelectorAll('.pp-gallery-thumb').forEach(function(t) { t.classList.remove('is-active'); });
      this.classList.add('is-active');
      var img = this.querySelector('img');
      if (mainImg && img) {
        var src = img.getAttribute('src');
        if (src) {
          mainImg.setAttribute('src', src.replace(/width=\d+/, 'width=960'));
          mainImg.setAttribute('srcset', '');
        }
      }
    });
  });

  /* FAQ accordion */
  document.querySelectorAll('.pp-faq-q').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = this.parentElement;
      var answer = this.nextElementSibling;
      var isOpen = answer.classList.contains('is-open');
      document.querySelectorAll('.pp-faq-a').forEach(function(a) { a.classList.remove('is-open'); });
      document.querySelectorAll('.pp-faq-item').forEach(function(i) { i.classList.remove('is-open'); });
      document.querySelectorAll('.pp-faq-q').forEach(function(q) { q.setAttribute('aria-expanded', 'false'); });
      if (!isOpen) {
        answer.classList.add('is-open');
        item.classList.add('is-open');
        this.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* Sticky bar — show after hero scrolls out, hide at footer */
  var stickyBar = document.querySelector('.pp-sticky-bar');
  var heroSection = document.querySelector('.pp-hero');
  var ppFooter = document.querySelector('.nf');
  if (stickyBar && heroSection) {
    window.addEventListener('scroll', function() {
      var bottom = heroSection.getBoundingClientRect().bottom;
      var footerVisible = ppFooter && ppFooter.getBoundingClientRect().top < window.innerHeight;
      if (bottom < 0 && !footerVisible) {
        stickyBar.classList.add('is-visible');
      } else {
        stickyBar.classList.remove('is-visible');
      }
    });
  }
})();
